// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "1.5rem";
var _4 = "header-SUax";
var _5 = "#dedede";
var _6 = "#adf";
var _7 = "1rem";
var _8 = "#bebebe";
var _9 = "messageContainer-JQLm";
var _a = "routePathCopySegmentView-qomo";
var _b = "routePathList-DJSG";
var _c = ".8rem";
var _d = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "extraLargeFontSize", _4 as "header", _5 as "lightGrey", _6 as "lightblue", _7 as "mediumFontSize", _8 as "mediumLightGrey", _9 as "messageContainer", _a as "routePathCopySegmentView", _b as "routePathList", _c as "smallFontSize", _d as "unusedNodeColor" }
